var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28.0009,
    rx: 14,
    fill: "#F4F6FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5099 8.43993L15.3743 9.57554L18.4245 12.6257L19.5601 11.4901C20.1466 10.9035 20.1466 9.9533 19.5601 9.36672L18.6356 8.43993C18.049 7.85336 17.0988 7.85336 16.5122 8.43993H16.5099ZM14.844 10.1058L9.37477 15.5774C9.13075 15.8214 8.95244 16.1241 8.85389 16.4549L8.0233 19.2775C7.96464 19.4769 8.01861 19.6905 8.16408 19.8359C8.30955 19.9814 8.52306 20.0354 8.72015 19.979L11.5428 19.1485C11.8736 19.0499 12.1763 18.8716 12.4203 18.6276L17.8942 13.156L14.844 10.1058Z",
    fill: "#A6A6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgEdit);
export default __webpack_public_path__ + "static/media/img_edit.45eaac0b6ca6ae58962d51fc8fcb81d8.svg";
export { ForwardRef as ReactComponent };